export default "__VITE_ASSET__D$6anN7a__"